import classNames from 'classnames';

import { formatHours } from 'utils/dayjs';

import type { CollectionOrderPaymentItem } from 'api';
import { convertTypeToLabel } from 'constants/paymentType';

import { PaymentBadge } from '@atoms/badges';

import { CopyToClipboardButton } from './CopyToClipboardButton';

type Props = {
  payment: CollectionOrderPaymentItem;
  className?: string;
};
export const OrderPaymentEntry = ({ payment, className = '' }: Props) => (
  <div
    className={classNames('details-section-items-container', className)}
    data-testid="order-details-payment-entry"
  >
    <div className="flex flex-col gap-2">
      <div className="text-xs">{convertTypeToLabel(payment.type)}</div>
      <PaymentBadge type={payment.status} />
    </div>
    <div className="flex flex-col">
      <div className="text-xs">{formatHours(payment.created_at, 'utc')}</div>
      <CopyToClipboardButton text={payment.unique_reference.toUpperCase()} />
    </div>
  </div>
);
